define('GridOrder.Confirmation.View', [
    'SCView',
    'grid_order_confirmation.tpl',
    'jQuery',
    'underscore'
], function (
    SCViewComponent,
    grid_order_confirmation_tpl,
    jQuery,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function GridOrderConfirmationView(options) {
        var _this = this;

        SCView.call(this);

        _this.options = options || {};

        _this.template = grid_order_confirmation_tpl;

        _this.attributes = { 
            id: 'GridOrder.Confirmation.View', 'class': 'grid-order-confirmation-view' 
        }

        _this.title = _('$(0) items were added successfully').translate(
            options.itemCount
        );
    }

    GridOrderConfirmationView.prototype = Object.create(SCView.prototype);

    GridOrderConfirmationView.prototype.constructor = GridOrderConfirmationView;

    GridOrderConfirmationView.prototype.getContext = function getContext() {
        var _this = this;
        
        return true;
    }

    return GridOrderConfirmationView;
});
